import classNames from 'classnames'
import Action from 'components/Action'
import Headings from 'components/Headings'
import style from 'components/PagePreviews.module.scss'
import ResourceList from 'components/ResourceList'
import { AnimatePresence, motion } from 'framer-motion'
import { Link } from 'gatsby'
import { childVariants, rootVariants, transitionDefaults } from 'lib/constants'
import { formatMarkdown, widont } from 'lib/helpers'
import React, { useState } from 'react'
import { useInView } from 'react-intersection-observer'

const PagePreviews = ({ heading, pages }) => {
  const [activePage, setActivePage] = useState(pages[0])

  const { ref, inView, entry } = useInView({
    triggerOnce: true,
  })

  const handleClick = (ev, page) => {
    ev.preventDefault()

    setActivePage(page)
  }

  return (
    <motion.div
      className={style.root}
      ref={ref}
      variants={rootVariants}
      initial="initial"
      animate={inView ? 'animate' : 'initial'}
      exit="exit"
    >
      <div className={style.content}>
        <div className={style.header}>
          <div className={style.headings}>
            <Headings mainHeading={heading} />
          </div>
          <div className={style.nav}>
            <ul className={style.navItems}>
              {pages.map(page => {
                const navLinkClass = classNames(style.navLink, {
                  [style.navLink___isActive]: activePage.id === page.id,
                })
                return (
                  <li key={page.id} className={style.navItem}>
                    <Link
                      to={`${
                        page.homepage ? '/' : `/${page.slug}`
                      }`}
                      onClick={ev => handleClick(ev, page)}
                      className={navLinkClass}
                    >
                      {page.title}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
        <AnimatePresence initial={false} exitBeforeEnter>
          <motion.div
            key={activePage.id}
            className={style.activePage}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={transitionDefaults}
          >
            <Page page={activePage} />
          </motion.div>
        </AnimatePresence>
      </div>
    </motion.div>
  )
}

const Page = ({ page }) => {
  return (
    <div className={style.page}>
      <div className={style.details}>
        <h3 className={style.title}>{page.title}</h3>
        {page.heroIntroduction && (
          <div
            className={style.introduction}
            dangerouslySetInnerHTML={{
              __html: formatMarkdown(page.heroIntroduction.heroIntroduction),
            }}
          />
        )}
        <div className={style.action}>
          <Action
            to={`${
              page.homepage ? '/' : `/${page.slug}`
            }`}
            label="Read More"
          />
        </div>
      </div>

      <div className={style.resourceList}>
        <ResourceList key={page.id} resources={page.resources} />
      </div>
    </div>
  )
}

export default PagePreviews
